import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { Dropdown, useInputValidation, typography } from '@landsbankinn/ui';
import React from 'react';
import { ConsultationType } from '../../../../../__generated__/globalTypes';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';
import res from './SelectService.res';

export interface IDropdown {
  label: string;
  value: string;
}

const Disabled = styled.div`
  padding: 24px 0px 16px 16px;
  width: 100%;
  background-color: rgb(220, 234, 240);
`;

const DisabledText = styled.p`
  ${typography.body}
`;

export function AppointmentSelectAccess() {
  const { r } = useResource();
  const { state, dispatch } = useAppointmentContext();

  const [ref, isValid] = useInputValidation(state?.serviceType, [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  if (state?.service?.types?.length === 1) {
    return (
      <Disabled>
        <DisabledText>
          {state.serviceType === ConsultationType.Phonecall
            ? r(res.phoneCallDisabled)
            : state.serviceType === ConsultationType.Appointment
            ? r(res.meeting)
            : r(res.videoCall)}
        </DisabledText>
      </Disabled>
    );
  }
  return (
    <>
      <Dropdown
        isValid={isValid}
        variant="noBorder"
        labelVariant="aboveInput"
        errorMessageVariant="insideInput"
        buildOption={(val) => val}
        options={
          state?.service !== undefined
            ? state.service?.types?.map((item) => ({
                label:
                  item.type === ConsultationType.Appointment
                    ? r(res.meeting)
                    : item.type === ConsultationType.Phonecall
                    ? r(res.phoneCall)
                    : r(res.videoCall),
                value: item.type,
              }))
            : []
        }
        onChange={(val?: IDropdown | null) => {
          dispatch?.({
            type: 'selectServiceType',
            serviceType: val?.value as ConsultationType,
          });
        }}
        value={
          state.serviceType !== undefined
            ? state.serviceType === ConsultationType.Appointment
              ? { label: r(res.meeting), value: ConsultationType.Appointment }
              : state.serviceType === ConsultationType.Phonecall
              ? { label: r(res.phoneCall), value: ConsultationType.Phonecall }
              : { label: r(res.videoCall), value: ConsultationType.Videocall }
            : undefined
        }
        label={r(res.pickType)}
      />
    </>
  );
}
